export const LICENSE_EXPIRATION_STATUS = {
  EXPIRED: 'expired',
  EXPIRING: 'expiring',
  VALID: 'valid',
};
